export default {
  NOTE: 'note',
};



// WEBPACK FOOTER //
// ./src/dnd/item-types.js